module.exports = __webpack_public_path__ + "static/img/8.d7fa586.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/8.jpg
// module id = t5ol
// module chunks = 1